export default __webpack_public_path__ + "static/media/importance.292aee19.png";